import { createFileRoute, redirect } from '@tanstack/react-router'

import i18n from '@/i18n'
import { UserCoursesView, coursesFiltersSchema } from '@/modules/courses'
import { userQueryOptions } from '@/modules/users'
import { semesterQueryOptions } from '@/queries/useSemesters'
import { getMetaWithPageTitle } from '@/utils/get-page-title'
import { isSelectedSemesterInOptions } from '@/utils/is-selected-semester-in-options'

export const Route = createFileRoute('/_auth/users/$userId/courses')({
  validateSearch: search => coursesFiltersSchema.parse(search),
  component: () => <UserCoursesView />,
  loaderDeps: ({ search }) => ({ search }),
  loader: async ({ deps: { search }, context, params }) => {
    const [semesters, user] = await Promise.all([
      context.queryClient.ensureQueryData(semesterQueryOptions({})),
      context.queryClient.ensureQueryData(userQueryOptions(params.userId))
    ])

    if (
      !search.semester ||
      !isSelectedSemesterInOptions(
        search.semester,
        semesters.semestersFromCurrentYearOptions
      )
    ) {
      throw redirect({
        replace: true,
        to: '/users/$userId/courses',
        params,
        search: {
          ...search,
          semester: semesters.currentSemester?.id
        }
      })
    }

    return user.name
  },
  head: ({ loaderData }) =>
    getMetaWithPageTitle([loaderData, i18n.t('title.courses', { ns: 'users' })])
})
